const featuredProducts = {
  featuredDiv: null,
  productIds: [],
  products: [],
  modalEl: null,
  modal: null,

  init() {
    const div = document.querySelector('.featured-products');
    if (!div) return;

    this.featuredDiv = div;

    const featuredPids = div.dataset.featuredPids;
    if (!featuredPids) return;

    this.productIds = featuredPids
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);

    this.createDescriptionModal();
    this.fetchProducts();
  },

  fetchProducts() {
    const productAPIUrl = 'product_api_url_replaced_during_build';
    const unpublishedData = 'product_unpublished_replaced_during_build';
    const fullSiteBuild = 'full_site_build_replaced_during_build';

    const params = new URLSearchParams();
    this.productIds.forEach((id) => params.append('productIds', id));

    const cookieTestPrice = pricing.readCookie('_up4tp');
    const cookieGroupId = pricing.readCookie('_up4gid');
    const cookieCoupon = pricing.readCookie('_up4cc');

    if (cookieTestPrice) params.append('testPrice', cookieTestPrice);
    if (cookieGroupId) params.append('groupId', cookieGroupId);
    if (cookieCoupon) params.append('couponcode', cookieCoupon);
    params.append('unpublished', unpublishedData);
    params.append('fullSiteBuild', fullSiteBuild);
    params.append('includeUpsells', false);

    const apiUrl = `${productAPIUrl}/GetProductsByIds/?${params.toString()}`;

    fetch(apiUrl)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (!Array.isArray(data) || !data.length) {
          console.warn('No featured products returned');
          return;
        }
        this.products = data;
        this.appendProducts(data);
      })
      .catch((err) => console.error('Failed to fetch featured products:', err));
  },

  // --- Utility: truncation (moved out of loop)
  truncateHtmlIntoString(html, maxLength = 130) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const text = doc.body.textContent || '';
    return text.length > maxLength ? text.slice(0, maxLength - 3) + '...' : text;
  },

  productItem(product) {
    const itemHtml = `
      <div class="card my-3">
        <div class="card-body text-center p-0 d-flex flex-column align-items-center">
          <div class="price ribbon mb-2" data-pid="${product.id}"><span class="dollar-sign">$</span><span class="dollars"></span>.<span class="cents"></span></div>
          <h2 class="h3 mb-3 px-4">${product.name}</h2>
          <a class="cta-btn red register-ipirp english-btn mb-3" href="#" data-pid="${product.id}">Sign Up</a>
        </div>
      </div>
    `;

    const template = document.createElement('template');
    template.innerHTML = itemHtml.trim();
    const component = template.content.firstElementChild;

    return component;
  },

  appendProducts() {
    const fragment = document.createDocumentFragment();
    const productMap = new Map(this.products.map((p) => [p.id, p]));

    this.productIds.forEach((id) => {
      const product = productMap.get(id);
      if (product) fragment.appendChild(this.productItem(product));
    });

    // this.featuredDiv.innerHTML = ''; // clear first if needed
    this.featuredDiv.appendChild(fragment);
  },

  createDescriptionModal() {
    const modalEl = document.createElement('div');
    modalEl.id = 'descriptionModal';
    modalEl.className = 'description-modal modal modal-lg fade';
    modalEl.tabIndex = -1;
    modalEl.innerHTML = `
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-0" style="max-width:800px;">
          <div class="modal-body">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            <div class="upsell-content">
              <h4 class="product-name"></h4>
              <div class="product-description"></div>
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(modalEl);
    this.modalEl = modalEl;
    this.modal = new bootstrap.Modal(modalEl);
  },

  showDescriptionModal(product) {
    const { modalEl, modal } = this;
    modalEl.querySelector('.product-name').textContent = product.name;
    modalEl.querySelector('.product-description').innerHTML = product.description || 'No description available.';
    modal.show();
  },
};

featuredProducts.init();
